/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ScheduleType } from '@gh/builder-shared-data';

@Component({
  standalone: false,
    selector: 'gh-schedule-gantt-header-dock',
    templateUrl: 'schedule-gantt-header-dock.component.html',
    styleUrls: ['../schedule-gantt-details-header-component.scss'],
})
export class ScheduleGanttHeaderDockComponent {
  @Input() details: any;
  @Input() unconfirmedTaskCount = 0;
  @Output() nextUnconfirmedTask = new EventEmitter<void>();

  get isConstruction(): boolean {
    return this.details.type === ScheduleType.Construction;
  }

  get isPreConstruction(): boolean {
    return this.details.type === ScheduleType.PreConstruction;
  }

  get isSales(): boolean {
    return this.details.type === ScheduleType.Sales;
  }

  get isMaintenance(): boolean {
    return this.details.type === ScheduleType.Maintenance;
  }

  onNextUnconfirmedVariation(): void {
    this.nextUnconfirmedTask.emit();
  }
}
